import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  dismissPendingListSortShares,
  showPendingListSortShares,
} from '../../../api/ListSort/dismissPendingListSortShares';

export function useDismissPendingListSortShares() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (dismissed: boolean) => (dismissed ? dismissPendingListSortShares() : showPendingListSortShares()),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ 'get-pending-list-sort-shares' ] });
    },
  });

  return {
    dismissPendingShares: () => mutation.mutate(true),
    showPendingShares: () => mutation.mutate(false),
    isPending: mutation.isPending,
  };
}
